import React from "react";
import "../Repertori.scss";
import { AddIcon } from "../../../assets/icons";
import CustomTooltip from "../../CustomTooltip";

const RepertoriHeader = ({ edit = false, onOpenModal }) => {
  return (
    <div className="repertori-header">
      <p className="repertori-header-title">Codici di inventario</p>
      {edit && (
        <CustomTooltip text="Aggiungi codice di inventario">
          <button className="repertori-button" onClick={onOpenModal}>
            <AddIcon fillColor="var(--archeo-color)" />
          </button>
        </CustomTooltip>
      )}
    </div>
  );
};

export default RepertoriHeader;
